export function getParentIframe() {
    return window.top;
}